import { toString30pk9tzaqopn as toString } from '../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Entry2xmjmyutzoq3p as Entry } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { MAP_getInstance141vh6u7faopd as MAP_getInstance } from '../descriptors/SerialKinds.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  buildSerialDescriptor2873qmkp8r2ib as buildSerialDescriptor,
  buildClassSerialDescriptors2a6xdp6mrtw as buildClassSerialDescriptor,
} from '../descriptors/SerialDescriptors.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  Paire9pteg33gng7 as Pair,
  to2cs3ny02qtbcb as to,
  Triple1vhi3d0dgpnjb as Triple,
} from '../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { SerializationExceptioneqrdve3ts2n9 as SerializationException } from '../SerializationExceptions.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../KSerializer.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function get_NULL() {
  _init_properties_Tuples_kt__dz0qyd();
  return NULL;
}
var NULL;
var MapEntryClass;
function MapEntry() {
  if (MapEntryClass === VOID) {
    class $ {
      constructor(key, value) {
        this.j26_1 = key;
        this.k26_1 = value;
      }
      m3() {
        return this.j26_1;
      }
      n3() {
        return this.k26_1;
      }
      toString() {
        return 'MapEntry(key=' + toString(this.j26_1) + ', value=' + toString(this.k26_1) + ')';
      }
      hashCode() {
        var result = this.j26_1 == null ? 0 : hashCode(this.j26_1);
        result = imul(result, 31) + (this.k26_1 == null ? 0 : hashCode(this.k26_1)) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof MapEntry()))
          return false;
        if (!equals(this.j26_1, other.j26_1))
          return false;
        if (!equals(this.k26_1, other.k26_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'MapEntry', VOID, VOID, [Entry()]);
    MapEntryClass = $;
  }
  return MapEntryClass;
}
var MapEntrySerializerClass;
function MapEntrySerializer() {
  if (MapEntrySerializerClass === VOID) {
    class $ extends KeyValueSerializer() {
      constructor(keySerializer, valueSerializer) {
        super(keySerializer, valueSerializer);
        var tmp = this;
        var tmp_0 = MAP_getInstance();
        tmp.n26_1 = buildSerialDescriptor('kotlin.collections.Map.Entry', tmp_0, [], ($this$buildSerialDescriptor) => {
          $this$buildSerialDescriptor.f1n('key', keySerializer.m1m());
          $this$buildSerialDescriptor.f1n('value', valueSerializer.m1m());
          return Unit_instance;
        });
      }
      m1m() {
        return this.n26_1;
      }
      o26(_this__u8e3s4) {
        return _this__u8e3s4.m3();
      }
      p26(_this__u8e3s4) {
        return this.o26((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Entry()) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      q26(_this__u8e3s4) {
        return _this__u8e3s4.n3();
      }
      r26(_this__u8e3s4) {
        return this.q26((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Entry()) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      s26(key, value) {
        return new (MapEntry())(key, value);
      }
    }
    initMetadataForClass($, 'MapEntrySerializer');
    MapEntrySerializerClass = $;
  }
  return MapEntrySerializerClass;
}
var PairSerializerClass;
function PairSerializer() {
  if (PairSerializerClass === VOID) {
    class $ extends KeyValueSerializer() {
      constructor(keySerializer, valueSerializer) {
        super(keySerializer, valueSerializer);
        var tmp = this;
        tmp.y26_1 = buildClassSerialDescriptor('kotlin.Pair', [], ($this$buildClassSerialDescriptor) => {
          $this$buildClassSerialDescriptor.f1n('first', keySerializer.m1m());
          $this$buildClassSerialDescriptor.f1n('second', valueSerializer.m1m());
          return Unit_instance;
        });
      }
      m1m() {
        return this.y26_1;
      }
      z26(_this__u8e3s4) {
        return _this__u8e3s4.ue_1;
      }
      p26(_this__u8e3s4) {
        return this.z26(_this__u8e3s4 instanceof Pair() ? _this__u8e3s4 : THROW_CCE());
      }
      a27(_this__u8e3s4) {
        return _this__u8e3s4.ve_1;
      }
      r26(_this__u8e3s4) {
        return this.a27(_this__u8e3s4 instanceof Pair() ? _this__u8e3s4 : THROW_CCE());
      }
      s26(key, value) {
        return to(key, value);
      }
    }
    initMetadataForClass($, 'PairSerializer');
    PairSerializerClass = $;
  }
  return PairSerializerClass;
}
function decodeSequentially($this, composite) {
  var a = composite.q1r($this.e27_1, 0, $this.b27_1);
  var b = composite.q1r($this.e27_1, 1, $this.c27_1);
  var c = composite.q1r($this.e27_1, 2, $this.d27_1);
  composite.e1r($this.e27_1);
  return new (Triple())(a, b, c);
}
function decodeStructure($this, composite) {
  var a = get_NULL();
  var b = get_NULL();
  var c = get_NULL();
  mainLoop: while (true) {
    var index = composite.u1r($this.e27_1);
    switch (index) {
      case -1:
        break mainLoop;
      case 0:
        a = composite.q1r($this.e27_1, 0, $this.b27_1);
        break;
      case 1:
        b = composite.q1r($this.e27_1, 1, $this.c27_1);
        break;
      case 2:
        c = composite.q1r($this.e27_1, 2, $this.d27_1);
        break;
      default:
        throw SerializationException().h1o('Unexpected index ' + index);
    }
  }
  composite.e1r($this.e27_1);
  if (a === get_NULL())
    throw SerializationException().h1o("Element 'first' is missing");
  if (b === get_NULL())
    throw SerializationException().h1o("Element 'second' is missing");
  if (c === get_NULL())
    throw SerializationException().h1o("Element 'third' is missing");
  return new (Triple())(a, b, c);
}
var TripleSerializerClass;
function TripleSerializer() {
  if (TripleSerializerClass === VOID) {
    class $ {
      constructor(aSerializer, bSerializer, cSerializer) {
        this.b27_1 = aSerializer;
        this.c27_1 = bSerializer;
        this.d27_1 = cSerializer;
        var tmp = this;
        tmp.e27_1 = buildClassSerialDescriptor('kotlin.Triple', [], ($this$buildClassSerialDescriptor) => {
          $this$buildClassSerialDescriptor.f1n('first', this.b27_1.m1m());
          $this$buildClassSerialDescriptor.f1n('second', this.c27_1.m1m());
          $this$buildClassSerialDescriptor.f1n('third', this.d27_1.m1m());
          return Unit_instance;
        });
      }
      m1m() {
        return this.e27_1;
      }
      f27(encoder, value) {
        var structuredEncoder = encoder.d1r(this.e27_1);
        structuredEncoder.v1s(this.e27_1, 0, this.b27_1, value.dt_1);
        structuredEncoder.v1s(this.e27_1, 1, this.c27_1, value.et_1);
        structuredEncoder.v1s(this.e27_1, 2, this.d27_1, value.ft_1);
        structuredEncoder.e1r(this.e27_1);
      }
      n1m(encoder, value) {
        return this.f27(encoder, value instanceof Triple() ? value : THROW_CCE());
      }
      o1m(decoder) {
        var composite = decoder.d1r(this.e27_1);
        if (composite.t1r()) {
          return decodeSequentially(this, composite);
        }
        return decodeStructure(this, composite);
      }
    }
    initMetadataForClass($, 'TripleSerializer', VOID, VOID, [KSerializer()]);
    TripleSerializerClass = $;
  }
  return TripleSerializerClass;
}
var KeyValueSerializerClass;
function KeyValueSerializer() {
  if (KeyValueSerializerClass === VOID) {
    class $ {
      constructor(keySerializer, valueSerializer) {
        this.t26_1 = keySerializer;
        this.u26_1 = valueSerializer;
      }
      v26(encoder, value) {
        var structuredEncoder = encoder.d1r(this.m1m());
        structuredEncoder.v1s(this.m1m(), 0, this.t26_1, this.p26(value));
        structuredEncoder.v1s(this.m1m(), 1, this.u26_1, this.r26(value));
        structuredEncoder.e1r(this.m1m());
      }
      n1m(encoder, value) {
        return this.v26(encoder, value);
      }
      o1m(decoder) {
        // Inline function 'kotlinx.serialization.encoding.decodeStructure' call
        var descriptor = this.m1m();
        var composite = decoder.d1r(descriptor);
        var tmp$ret$1;
        $l$block: {
          if (composite.t1r()) {
            var key = composite.q1r(this.m1m(), 0, this.t26_1);
            var value = composite.q1r(this.m1m(), 1, this.u26_1);
            tmp$ret$1 = this.s26(key, value);
            break $l$block;
          }
          var key_0 = get_NULL();
          var value_0 = get_NULL();
          mainLoop: while (true) {
            var idx = composite.u1r(this.m1m());
            switch (idx) {
              case -1:
                break mainLoop;
              case 0:
                key_0 = composite.q1r(this.m1m(), 0, this.t26_1);
                break;
              case 1:
                value_0 = composite.q1r(this.m1m(), 1, this.u26_1);
                break;
              default:
                throw SerializationException().h1o('Invalid index: ' + idx);
            }
          }
          if (key_0 === get_NULL())
            throw SerializationException().h1o("Element 'key' is missing");
          if (value_0 === get_NULL())
            throw SerializationException().h1o("Element 'value' is missing");
          tmp$ret$1 = this.s26(key_0, value_0);
        }
        var result = tmp$ret$1;
        composite.e1r(descriptor);
        return result;
      }
    }
    initMetadataForClass($, 'KeyValueSerializer', VOID, VOID, [KSerializer()]);
    KeyValueSerializerClass = $;
  }
  return KeyValueSerializerClass;
}
var properties_initialized_Tuples_kt_3vs7ar;
function _init_properties_Tuples_kt__dz0qyd() {
  if (!properties_initialized_Tuples_kt_3vs7ar) {
    properties_initialized_Tuples_kt_3vs7ar = true;
    NULL = new Object();
  }
}
//region block: exports
export {
  MapEntrySerializer as MapEntrySerializer2ukwamih4zw76,
  PairSerializer as PairSerializerpzh6nuee9oov,
  TripleSerializer as TripleSerializer25andm5j3t9nu,
};
//endregion

//# sourceMappingURL=Tuples.mjs.map
